const firebaseConfig = {
    apiKey: "AIzaSyCT1oSwp6z51Q1E1Ir5t9-WYfGqE_HOj0s",
    authDomain: "talhamedicare.firebaseapp.com",
    projectId: "talhamedicare",
    storageBucket: "talhamedicare.appspot.com",
    messagingSenderId: "837991188047",
    appId: "1:837991188047:web:ee2246be04b238bfe7cc3a"
};
export default firebaseConfig;